// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Rvzgg","bigColWidth":"Table_bigColWidth__3rRub","biggerColWidth":"Table_biggerColWidth__2x4yl","row":"Table_row__2PQeO","col":"Table_col__2B6CK"};